import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import { useSortedPaginated, SortableTh, Pagination } from '../components/TableControls';

export default function StoreInventory() {
  const { storeId } = useParams();
  const [inventory, setInventory] = useState([]);
  const [storeName, setStoreName] = useState('');
  const { paginated, sortKey, sortDir, setSort, page, setPage, perPage, setPerPage, total } = useSortedPaginated(inventory, 'item_name');

  useEffect(() => {
    api.get(`/stores/${storeId}/inventory`).then(r => setInventory(r.data));
    api.get('/stores').then(r => {
      const s = r.data.find(s => s.id === parseInt(storeId));
      if (s) setStoreName(s.name);
    });
  }, [storeId]);

  return (
    <div>
      <div className="page-header"><h1>{storeName} - Inventario Actual</h1></div>
      <div className="card">
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <SortableTh colKey="item_name" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Artículo</SortableTh>
                <SortableTh colKey="item_category" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Categoría</SortableTh>
                <SortableTh colKey="quantity" sortKey={sortKey} sortDir={sortDir} onSort={setSort}>Cantidad</SortableTh>
              </tr>
            </thead>
            <tbody>
              {inventory.length === 0 && <tr><td colSpan={3}>Sin datos de inventario. Usa Importación Masiva para establecer los balances iniciales.</td></tr>}
              {paginated.map(i => (
                <tr key={i.item_id}>
                  <td>{i.item_name}</td>
                  <td>{i.item_category || '-'}</td>
                  <td>{i.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination page={page} perPage={perPage} total={total} onPage={setPage} onPerPage={setPerPage} />
      </div>
    </div>
  );
}
